/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsDealerLocatorViewProps } from '../../../modules/hosports-dealer-locator/./hosports-dealer-locator';
//@ts-ignore
import DealerLocator from '../../../baseComponents/dealer-map/./index';

export default (props: IHosportsDealerLocatorViewProps) => {
  let config = props.config;
  let brand = config.brand;
  return (
      <DealerLocator
        brand={brand}
        enRetailers={config.enRetailers}
        deRetailers={config.deRetailers}
        euRetailers={config.euRetailers}
        auRetailers={config.auRetailers}
        ruRetailers={config.ruRetailers}
        ukRetailers={config.ukRetailers}
      />
  );
};
